export interface PlaceDto {
  city: string,
  street?: string,
  users: number[],
}

export class Place implements PlaceDto {
  city!: string;
  street?: string = undefined;
  users: number[] = [];
  id: string = '';

  constructor(dto?: PlaceDto) {
    if (dto) {
      Object.assign(this, dto);
      this.id = `${this.street || ''}${this.city}${this.users}`;
    }
  }

  // When places in select has a placeholder values (like)
  // Gdańsk wszystkie placówki
  // then we don't provide specific street or city
  // so the id of this place is undefined + users
  get hasAddress(): boolean {
    return !!this.street && !!this.city;
  }
}
